module.exports = "/_next/static/images/about-db71d854bc629a14ed7d983ffa9bd75c.png";